import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'
import { useStore } from 'vuex-composition-helpers'
import { AxiosError } from 'axios'
import { getShortCodeSuggestion } from '@/api/companies'
import { useJobFilterStore } from '@/components/field-view-next/JobsFilterStore'
import { useCreateClientMutation } from '@/api/account-data/manage-companies'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import VsButton from '@/components/vision/VsButton.vue'
import VsForm from '@/components/vision/VsForm.vue'
import VsTextInput from '@/components/vision/Inputs/VsTextInput.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'CreateClientForm',
  props: {
    initialClientName: null
  },
  emits: ["create-client-success", "create-client-failure", "discard"],
  setup(__props: any, { emit }: { emit: ({
  (
    e: 'create-client-success',
    data: {
      clientHubId: string
      clientHubName: string
      createNewJob: boolean
    }
  )
  (e: 'create-client-failure', error: unknown)
  (e: 'discard')
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  initialClientName: string
}





const name = ref<string | null>()
const shortCode = ref<string | null>()
const billingAddress = ref<string | null>()

const isLoadingShortNameSuggestion = ref<boolean>(false)

const filterStore = useJobFilterStore()

const { mutateAsync: createClient, isLoading: creatingClient } =
  useCreateClientMutation()

watch(
  () => props.initialClientName,
  (newVal) => {
    name.value = newVal
  },
  { immediate: true }
)

const handleNameBlur = () => {
  if (name.value && !shortCode.value) {
    handleSuggestShortCode()
  }
}

const handleSuggestShortCode = async () => {
  isLoadingShortNameSuggestion.value = true
  setTimeout(async () => {
    try {
      const res = await getShortCodeSuggestion(name.value)
      shortCode.value = res.shortCode ?? null
    } catch (e) {
    } finally {
      isLoadingShortNameSuggestion.value = false
    }
  }, 300)
}

// Submission
const form = ref()
const store = useStore()

const submit = async (navigateToNewJobPage: boolean) => {
  if (!form.value.isValid()) {
    return
  }
  try {
    const response = await createClient({
      name: name.value ?? '',
      shortCode: shortCode.value ?? '',
      billingAddress: billingAddress.value,
    })
    const clientOrgId = response.data?.organization?.id
    const clientHubId = response.data?.hub?.id

    if (!clientOrgId || !clientHubId) {
      emit('create-client-failure', 'Unknown error occurred')
      return
    }

    await Promise.all([
      store.dispatch('fetchJobData', true),
      store.dispatch('permissions/fetchCurrentUserContext'),
    ])
    updateDivisionFilters(clientHubId)
    emit('create-client-success', {
      clientHubId,
      clientHubName: response.data?.organization?.name ?? '',
      createNewJob: navigateToNewJobPage,
    })
  } catch (err: unknown) {
    setError(err)
  }
}

const updateDivisionFilters = (newHubId: string) => {
  const currentFilters = filterStore.selectedDivisions
  const newDivId =
    store.getters['divisions/getDivisionsForHub'](newHubId)?.[0]?.uuid

  if (newDivId && currentFilters.length > 0) {
    filterStore.updateDivision([...currentFilters, newDivId])
  }
}

const setError = (err: any) => {
  let extractedErr: string | null = null
  try {
    switch (err?.constructor) {
      case AxiosError:
        extractedErr = Object.values(err?.response?.data?.errors).join(' ')
        break
      case Error:
        extractedErr = err?.message
    }
  } finally {
    emit('create-client-failure', extractedErr || 'Unknown error occurred')
  }
}

return { __sfc: true,props, emit, name, shortCode, billingAddress, isLoadingShortNameSuggestion, filterStore, createClient, creatingClient, handleNameBlur, handleSuggestShortCode, form, store, submit, updateDivisionFilters, setError, VsWrapper, VsButton, VsForm, VsTextInput }
}

})